import { KeyboardUtils} from 'neo-common';
import {registerClientHost} from '../ClientHostFactory';
import {
    ClientHostActionGroup
} from '../Types';
import {DefaultGameActions} from '../Constants';
import {IClientHostConsumer} from '../IClientHostConsumer';
import {ClientHostDefault} from './ClientHostDefault';

const version = '1';
const typeName = 'Desktop';

@registerClientHost(typeName)
export class ClientHostDesktop extends ClientHostDefault {
    constructor(clientHostConsumer: IClientHostConsumer) {
        super(clientHostConsumer);

        this.handleKeySpacebar = this.handleKeySpacebar.bind(this);

        KeyboardUtils.bindKeyRelease('space', this.handleKeySpacebar);
    }

    protected getLogger(): string {
        return 'ClientHostDesktop';
    }

    private handleKeySpacebar(): void {
        this.dispatchAction(ClientHostActionGroup.Default, DefaultGameActions.ActionSpinOrStop);
    }

    public get version(): string {
        return version;
    }

    public get type(): string {
        return typeName;
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/ClientHost/Common/ClientHostDesktop.ts
 **/